import styled from "styled-components";

export const ContainerConfig = styled.div`
  background: var(--color-secondary-gradient);
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  overflow-y: auto;
  color: var(--color-white);
  display: flex;
  padding-top: 260px;
  align-items: center;
  flex-direction: column;
  @media (max-width: 1366px) {
    padding-top: 150px;
  }
  h1 {
    margin: 0;
    padding: 0;
  }
  .container-input {
    width: 500px;
    height: 600px;
    background-color: var(--color-white);
  }
`;

export const ConfigFooter = styled.div`
  background-color: var(--color-latex10);
  height: 278px;
  width: 100vw;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 0;
`;

export const ConfigCurva = styled.div`
  background-color: var(--color-latex10);
  height: 40px;
  border-radius: 50%;
  width: 120vw;
  position: absolute;
  top: -30px;
  background-color: var(--color-latex10);
`;

export const ConfigTecladoContainer = styled.div`
  width: 808px;
`;
